import { useContext } from "react";

import AppContext from "../../../../AppContext";
import useReleaseReservation from "../Hooks/UseReleaseReservation";

const AppContextUseReleaseReservation = () => {
  const { contactId, patient } = useContext(AppContext);
  return useReleaseReservation({ patientId: patient.id, contactId: contactId });
};

export default AppContextUseReleaseReservation;
